module.exports = __webpack_public_path__ + "static/media/w (9).70b8b8fc.jpg";